import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Radio } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
function getBorderRadiusHorizontal(listIndex) {
  switch (listIndex) {
    case 0:
      return 'var(--chakra-space-1) 0 0 var(--chakra-space-1)';
    case 'last':
      return '0  var(--chakra-space-1) var(--chakra-space-1) 0';
    case 'left':
      return 'var(--chakra-space-1) 0 0 var(--chakra-space-1)';
    case undefined:
      return '4';
    default:
      return '0';
  }
}
function getBorderRadiusVertical(listIndex) {
  switch (listIndex) {
    case 0:
      return 'var(--chakra-space-1) var(--chakra-space-1) 0 0';
    case 'last':
      return '0 0 var(--chakra-space-1) var(--chakra-space-1)';
    case 'left':
      return 'var(--chakra-space-1) 0 0 var(--chakra-space-1)';
    case undefined:
      return '4';
    default:
      return '0';
  }
}
function getBorderWidth(isBorderless, isChecked) {
  if (isBorderless) {
    return 0;
  }
  if (isChecked) {
    return '2px';
  }
  return '1px';
}
function getBorderBottomWidth(isBorderless, isChecked, listIndex) {
  if (isBorderless) {
    return 0;
  }
  if (isChecked) {
    return '2px';
  }
  if ([undefined, 0, 'last', 'left'].includes(listIndex)) {
    return '1px';
  }
  return '1px';
}
var radioButtonStyle = (isBorderless, isChecked, listIndex) => ({
  borderWidth: getBorderWidth(isBorderless, isChecked),
  borderBottomWidth: {
    base: getBorderBottomWidth(isBorderless, isChecked, listIndex)
  },
  borderStyle: 'solid',
  borderColor: isChecked ? 'primary' : 'lightGrey3',
  borderRadius: {
    base: getBorderRadiusVertical(listIndex),
    md: getBorderRadiusHorizontal(listIndex)
  },
  p: isBorderless ? '0' : 'md',
  background: isChecked ? 'lightGrey5' : 'baseWhite'
});
export default function PaymentRadioButton(props) {
  return _jsx(Box, _objectSpread(_objectSpread({
    "data-testid": props.type ? "radio-box-wrapper_".concat(props.type) : 'radio-box-wrapper'
  }, radioButtonStyle(props.variant === 'borderless', props.isChecked, props.listIndex)), {}, {
    w: "full",
    maxW: {
      base: '100%',
      lg: props.maximumWidth
    },
    children: _jsx(Radio, _objectSpread(_objectSpread({
      "data-testid": props.type ? "radio-box-inside_".concat(props.type) : 'radio-box-inside',
      alignItems: "flex-start",
      width: "full",
      variant: "payment"
    }, props), {}, {
      children: props.children
    }))
  }));
}